import { render, staticRenderFns } from "./group.principal.vue?vue&type=template&id=4ed94f15&scoped=true&"
import script from "./group.principal.vue?vue&type=script&lang=js&"
export * from "./group.principal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed94f15",
  null
  
)

export default component.exports